import React from 'react';
import PageHero from '../components/site/PageHero';
import { faqs } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { CtaBanner } from '../components/site/BottomSections';

export default function FAQ() {
  return (
    <div>
      <PageHero eyebrow="Help Center" title="Answers to the questions we hear most." subtitle="Still curious? Just call us — we love talking about the mountains." image="https://ewenrealtors.com/assets/23_04_25/banners/web-banner3%20copy.webp" />
      <section className="bg-white py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-[#0f1a14]/10 bg-[#f6f1e7]/40 px-6">
                <AccordionTrigger className="text-left font-serif text-lg text-[#0f1a14] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#0f1a14]/70 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <CtaBanner />
    </div>
  );
}
